import React from 'react';
import { Grid } from '@mui/material';
import { Websites } from '../Websites.js';

export function WebsitesPage() {
  return (
    <Grid container spacing={1}>
      <Websites />
    </Grid>
  );
}
